/**
 * Doble búfer de los frames raster (pmtiles o WMS): llama a `done` cuando todas las fuentes tienen las teselas del
 * viewport (una con error cuenta como terminada). Hasta entonces el mapa sigue enseñando el frame anterior en vez de
 * quedarse en blanco. Como mucho `maxWaitMs` (Windy fuerza el cambio a los 3 s): una tesela lenta no deja el mapa en la
 * hora anterior mientras el slider ya marca la nueva; lo que falte aparece al llegar, con la píldora de carga puesta.
 * Devuelve la función que quita los listeners
 */
export const whenSourcesLoaded = (map, sourceIds, done, maxWaitMs = 3000) => {
  const pending = new Set(sourceIds);
  let timer = null;
  const off = () => {
    clearTimeout(timer);
    map.off('sourcedata', check);
    map.off('error', check);
  };
  function check(e) {
    if (e?.type === 'error') pending.delete(e.sourceId);
    pending.forEach((id) => {
      try {
        // Sin la fuente isSourceLoaded lanza un evento 'error' que volvería a entrar aquí: se da por terminada
        if (!map.getSource(id) || map.isSourceLoaded(id)) pending.delete(id);
      } catch (err) {
        pending.delete(id); // mapa ya desmontado
      }
    });
    if (pending.size) return;
    off();
    done();
  }
  map.on('sourcedata', check);
  map.on('error', check);
  timer = setTimeout(() => {
    off();
    done();
  }, maxWaitMs);
  check();
  return off;
};
